import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { StatusCodes } from 'http-status-codes';
import { useHistory, useParams, useLocation } from 'react-router-dom';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import InventoryApi from '../../../../services/api/InventoryApi';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import GenericProductsApi from '../../../../services/api/GenericProductsApi';
import InventoryAddEditForm from '../components/InventoryAddEditForm';
import { fullSchema } from '../InventorySchema';
import { InventoryFormikValuesDto } from '~/src/types/InventoryFormikValuesDto';
import { formikToTransactionAddDto } from '~/src/types/convertors/formikToTransactionAddDto';
import { quantityGetDtoToFormik } from '~/src/types/convertors/quantityGetDtoToFormik';

interface ParamProps {
  genericId: string;
}

export default function InventoryAdjustment(): JSX.Element {
  const { genericId } = useParams<ParamProps>();
  const history = useHistory();
  const location = useLocation();
  const { item, type } = location?.state ?? {};
  const [generic, setGeneric] = useState(null);

  const saveItem = async (
    values: InventoryFormikValuesDto,
    setSubmitting: (isSubmitting: boolean) => void,
  ): Promise<void> => {
    setSubmitting(true);
    const updatedValues = formikToTransactionAddDto(values, genericId);
    let result;
    if (type === 'with') {
      result = await InventoryApi.adjust(updatedValues);
    }

    if (type === 'to') {
      result = await InventoryApi.adjustTo(updatedValues);
    }

    if (result.status === StatusCodes.OK) {
      history.push(`/inventory/list-for-generic/in-warehouse/${updatedValues.warehouseId}/${genericId}`);
    } else {
      setSubmitting(false);
    }
  };

  const getGenericItem = async (): Promise<void> => {
    const result = await GenericProductsApi.get(genericId);
    setGeneric(result.data);
  };

  const initialValues = quantityGetDtoToFormik(item, false);

  const formik = useFormik({
    initialValues,
    validationSchema: fullSchema,
    onSubmit: async (values, { setSubmitting }) => {
      return saveItem(values, setSubmitting);
    },
  });

  useEffect(() => {
    if (genericId) {
      getGenericItem();
    }
  }, []);

  return (
    <WhitePad isFluid>
      <TitleComponent
        onLeftHandler={(): void => {
          history.goBack();
        }}
        title={`Adjust Inventory ${type}`}
      />
      {generic && <InventoryAddEditForm formikProps={formik} generic={generic} />}
    </WhitePad>
  );
}
